import { MutateOptions, UseMutationResult, useMutation } from 'react-query';
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../utils/alert';
import { getDownloadResult, reprocessarOs } from '..';

//#region BAIXAR ANÁLISE (RESULTADO PROCESSADO)
interface ParamsDownloadResultado {
    arquivo_processado_url: string
    cod: number
}

export const useDownloadResultado = (): {
    carregando_download: boolean;
    mutate_download: (params: ParamsDownloadResultado) => void;
} => {

    const mutation: UseMutationResult<void, Error, ParamsDownloadResultado> = useMutation(
        async (params: ParamsDownloadResultado) => {
            const { arquivo_processado_url, cod } = params;

            if (!arquivo_processado_url) {
                errorAlert('Não encontramos arquivos processados. Faça o upload de um arquivo para prosseguir', 5000);
                return;
            }

            loadingAlert({ msg: 'Baixando análise...', id: 'download_os' });

            return getDownloadResult(arquivo_processado_url)
                .then((response: any) => {
                    const url = URL.createObjectURL(response.data);
                    const link = document.createElement('a');
                    link.href = url;
                    const nomeArquivo = arquivo_processado_url.split('/').pop()?.split('?')[0]?.split('#')[0];
                    link.download = nomeArquivo || `analise_${cod}`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setTimeout(() => URL.revokeObjectURL(url), 1000);
                    destroyAlert('download_os');
                })
                .catch((error: any) => {
                    errorAlert('Falha ao baixar a análise.', 5000, 'download_os');
                    throw error;
                });
        }
    );

    return {
        carregando_download: mutation.isLoading,
        mutate_download: mutation.mutate,
    };
};
//#endregion

//#region REPROCESSAR OS
interface ParamsReprocessarOs {
    cod: number
    cod_cliente: number
    refetch?: Function
}

export const useReprocessarOs = (): {
    carregando_reprocessar: boolean;
    mutate_reprocessar: (
        params: ParamsReprocessarOs,
        options?: MutateOptions<void, Error, ParamsReprocessarOs>
    ) => void;
} => {

    const mutation: UseMutationResult<void, Error, ParamsReprocessarOs> = useMutation(
        async (params: ParamsReprocessarOs) => {
            const { cod, cod_cliente, refetch } = params;

            loadingAlert({ msg: 'Reprocessando OS...', id: 'proce_os' });

            return reprocessarOs(cod, cod_cliente)
                .then((response: any) => {
                    if (response.status !== 200) {
                        throw new Error('Falha ao reprocessar a OS.');
                    }
                    successAlert('OS reprocessada com sucesso!', 5000, 'proce_os');
                    refetch?.();
                })
                .catch((error: any) => {
                    errorAlert('Ocorreu um erro ao reprocessar a OS.', 5000, 'proce_os');
                    throw error;
                });
        }
    );

    return {
        carregando_reprocessar: mutation.isLoading,
        mutate_reprocessar: mutation.mutate,
    };
};
//#endregion
